export default {
  time_options: {
    asap: {
      title: 'Jak najszybciej',
      description: 'Gotowe za {{time}} min',
    },
    scheduled: {
      title: 'Zaplanuj na później',
    },
  },
};
